import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import gsap from "gsap";
import ScrollTo from "gsap/ScrollToPlugin";

const Header = () => {

    const [menu, setMenu] = useState(false);
    const menuShow = () => {
        if (window.innerWidth < 1199) {
            setMenu(!menu)
        }
    }

    gsap.registerPlugin(ScrollTo);


    const location = useLocation();

    if (window.location.hash) {
        console.log("hash");
        window.history.replaceState("", document.title, window.location.pathname);
    }

    const navigate = useNavigate();

    const pageTo = (section) => {
        if (location.pathname !== "/") {
            navigate('/' + section, { replace: true });
        } else {
            window.scrollBy({
                top: document.querySelector(section).getBoundingClientRect().top - 75,
                behavior: "smooth",
            });

            // gsap.to(window, {
            //     scrollTo: {
            //         y: document.querySelector(section).getBoundingClientRect().top - 75,
            //         autoKill: false
            //     },
            //     duration: 1
            // });
        }
    };

    useEffect(() => {
        setTimeout(() => {
            if (location.hash) {
                window.scrollBy({
                    top:
                        document.querySelector(location.hash).getBoundingClientRect().top -
                        75,
                    behavior: "smooth",
                });
            }
        }, 150)
    }, [location]);





    return (
        <header className="navbar-index" id="navbar">
            <nav className="navbar navbar-expand-xl align-items-center ">
                <div className="container container-cus1190">
                    <a href="/" className="navbar-brand hm-navbar-brand">
                        <div className="log-img">
                            <img src={require("../../../assets/images/logo.png")} alt="" className="img-fluid" />
                        </div>
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded={`${menu ? 'true' : 'false'}`} aria-label="Toggle navigation" onClick={menuShow}>
                        <div className="smClose">
                            <svg id="closeicon" viewBox="0 0 800 600">
                                <path
                                    d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
                                    id="top">
                                </path>
                                <path d="M300,320 L460,320" id="middle"></path>
                                <path
                                    d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
                                    id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) ">
                                </path>
                            </svg>
                        </div>
                    </button>
                    <div className={`collapse navbar-collapse pdswpmu ${menu ? 'show' : ''}`.trim()} id="navbarSupportedContent">
                        <ul className="navbar-nav HeaderMenu_listone m-auto align-items-center">
                            <li className="nav-item active">
                                <button className="btn" onClick={() => { pageTo("#about") }}>
                                    About ROU
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="btn" onClick={() => { pageTo("#tokenomics") }}>
                                    Tokenomics
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="btn" onClick={() => { pageTo("#ecosystem") }}>
                                    ROU Ecosystem
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="btn" onClick={() => { pageTo("#roadmap") }}>
                                    Roadmap
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="btn" onClick={() => { pageTo("#ourteam") }}>
                                    Our Team
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="btn" onClick={() => { pageTo("#homeFaq") }}>
                                    FAQ
                                </button>                                
                            </li>
                            <li className="nav-item">
                                <a className=" nav-link " href="/">Contact Us</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    )
}
export default Header;